import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import cn from 'classnames';
import Icon from 'chameleon/ui-stack/ui/base/icon';
import {
  Context,
  toggleMainNav,
} from 'chameleon/ui-stack/ui/basic/main-nav-two-levels';

const SecondLevelItem = (props) => {
  const [, dispatch] = useContext(Context);
  const { tag, className, item } = props;
  const NavTag = tag;
  const {
    label,
    secondaryLabel = '',
    to = '#',
    isActive,
    onClick,
    showNotifIcon,
    notifIconTitle,
    indent = false,
    id,
  } = item;

  let ariaProps = {};
  if (isActive) {
    ariaProps['aria-current'] = 'page';
  }

  const onClickWrapper = () => {
    onClick && onClick();
    document.querySelector('#main-content')?.focus();
    toggleMainNav(dispatch, false);
  };

  const handleClickOnLink = (e) => {
    if (to === '#') {
      e.preventDefault();
    }
  };

  return (
    <NavTag onClick={onClickWrapper} className={cn(className)}>
      <Link
        tabIndex={0}
        className="flex text-gray-900 relative"
        to={to}
        onlyActiveOnIndex={false}
        data-nav-id={id}
        onClick={handleClickOnLink}
        {...ariaProps}
      >
        <span
          className={cn(
            'text-base flex w-full py-5 items-center hover:bg-blue-600 hover:bg-opacity-10',
            'h-20 font-medium',
            {
              'bg-blue-600 bg-opacity-10 underline': isActive,
              'pl-4.6': !indent,
              'pl-12.2': indent,
            },
          )}
        >
          <span className="relative whitespace-normal">
            {label}
            {showNotifIcon && (
              <Icon
                accessibility={{ title: notifIconTitle }}
                className="absolute text-red-600 -top-2"
                id="circle"
              />
            )}
          </span>
        </span>
        {secondaryLabel}
      </Link>
    </NavTag>
  );
};

SecondLevelItem.propTypes = {
  className: PropTypes.string,
  tag: PropTypes.string,
  item: PropTypes.shape({
    label: PropTypes.string,
    isActive: PropTypes.bool,
  }).isRequired,
  onClick: PropTypes.func,
  showNotifIcon: PropTypes.bool,
};

SecondLevelItem.defaultProps = {
  className: null,
  tag: 'li',
  onClick: () => {},
  showNotifIcon: false,
};

export default SecondLevelItem;
